import { useEffect } from 'react';

/**
 * Hook personalizado para cerrar modales con la tecla ESC
 * @param {boolean} isOpen - Si el modal está abierto
 * @param {function} onClose - Función a ejecutar para cerrar el modal
 * @param {boolean} preventDefault - Si prevenir el comportamiento por defecto (default: true)
 */
export const useModalEscape = (isOpen, onClose, preventDefault = true) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        if (preventDefault) {
          event.preventDefault();
        }
        onClose();
      }
    };

    // Agregar listener con captura para prioridad alta
    document.addEventListener('keydown', handleEscape, true);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleEscape, true);
    };
  }, [isOpen, onClose, preventDefault]);
};